import {Component, ViewEncapsulation} from '@angular/core';
import {ResponseDtoType} from '../../../dto/ResponseDtoType';
import {DelayedRenderedMessageComponent} from '../delayed-rendered-message-component';

@Component({
    templateUrl: './image-message.component.html',
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class ImageMessageComponent extends DelayedRenderedMessageComponent {

    public static TYPE: ResponseDtoType = 'image';

    public imageLoaded(): void {
        this.componentRenderingCompleted();
    }
}
